import { render } from "./PageButton.vue?vue&type=template&id=65d0d30c&scoped=true"
import script from "./PageButton.vue?vue&type=script&lang=js"
export * from "./PageButton.vue?vue&type=script&lang=js"

import "./PageButton.vue?vue&type=style&index=0&id=65d0d30c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d0d30c"],['__file',"src/components/h5/button/PageButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65d0d30c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65d0d30c', __exports__)) {
    api.reload('65d0d30c', __exports__)
  }
  
  module.hot.accept("./PageButton.vue?vue&type=template&id=65d0d30c&scoped=true", () => {
    api.rerender('65d0d30c', render)
  })

}


export default __exports__